<template>
  <div class="CommentRecord">
    <a-form-model layout="inline" style="margin-top: 15px">
      <a-form-model-item label="游戏名称" required>
        <a-select @change="changeGame" style="width: 198px" :filter-option="filterOption" :showSearch="true" v-model="search.contentName" placeholder="请选择游戏名称">
          <a-select-option :value="item.id" v-for="item in gameListDuplicate" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="版本名称">
        <a-select allowClear v-model="search.gameVersion" placeholder="请选择版本名称" style="min-width: 180px" @change="changeGameVersion">
          <a-select-option :value="item.versionName" :key="item.id" v-for="item in gameVersionList">{{ item.versionName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="版本号">
        <a-select style="min-width: 180px" allowClear v-model="search.version" placeholder="请选择版本号">
          <a-select-option :value="item.version" :key="item.id" v-for="item in versionList">{{ item.version }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="性别">
        <a-select allowClear v-model="search.gender" placeholder="请选择性别" style="width: 198px">
          <a-select-option :value="1">男</a-select-option>
          <a-select-option :value="2">女</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="年龄段">
        <a-input-group compact>
          <a-input-number style="width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="3" :max="150" v-model="search.minAge" />
          <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
          <a-input-number style="width: 100px; text-align: center; border-left: none" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="18" type="number" v-model="search.maxAge" />
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item label="跳过游戏环节">
        <a-select :maxTagCount="1" :filter-option="filterOption" allowClear v-model="search.stageType" placeholder="请选择跳过游戏环节" style="width: 198px">
          <a-select-option value="引导关">引导关</a-select-option>
          <a-select-option value="练习关">练习关</a-select-option>
          <a-select-option value="正式关">正式关</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳过原因">
        <a-select mode="multiple" :maxTagCount="1" :filter-option="filterOption" allowClear v-model="search.skipReason" placeholder="请选择跳过原因" style="width: 198px">
          <a-select-option value="我觉得不好玩">我觉得不好玩</a-select-option>
          <a-select-option value="游戏太难了，玩不下去">游戏太难了，玩不下去</a-select-option>
          <a-select-option value="太简单了，很无聊">太简单了，很无聊</a-select-option>
          <a-select-option value="我遇到问题了，打不开游戏">我遇到问题了，打不开游戏</a-select-option>
          <a-select-option value="我觉得没有效果">我觉得没有效果</a-select-option>
          <a-select-option value="其他原因">其他原因</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="时间区间" required>
        <a-range-picker
          v-model="times"
          @change="changeRange"
          :disabledDate="disabledDate"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="getList(1)">查询</a-button>
        <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
      </a-form-model-item>
      <div class="export-btn">
        <a-tooltip>
          <template slot="title">导出 </template>
          <a-icon @click="exportExecl" type="logout" style="font-size: 20px; cursor: pointer" />
        </a-tooltip>
      </div>
    </a-form-model>
    <div class="table">
      <a-table :columns="columns" :scroll="{ x: 1300 }" rowKey="id" @change="handleTableChange" :pagination="table.tablePagination" :loading="table.tableLoading" :dataSource="table.tableDataSource">
        <div slot="gender" slot-scope="text">{{ text == 1 ? '男' : '女' }}</div>
        <div slot="skipReason" slot-scope="text">
          <div v-for="(item, index) in text" :key="index">{{ item }}</div>
        </div>
        <div slot="stayTime" slot-scope="text">{{ formatTime(text) }}</div>
        <div slot="versionName" slot-scope="text">{{ text.versionName || '--' }}</div>
      </a-table>
    </div>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { ContentSkipInfoPageList, GamesComment, EGamegeVersion } from '@/utils/http'
import * as XLSX from 'xlsx'
import moment from 'moment'

const columns = [
  { title: '用户名', dataIndex: 'realName', fixed: 'left', width: 130 },
  { title: '性别', dataIndex: 'gender', scopedSlots: { customRender: 'gender' }, width: 70 },
  { title: '年龄', dataIndex: 'age', width: 70 },
  { title: '游戏名', dataIndex: 'contentName' },
  {
    title: '版本号',
    dataIndex: 'version',
  },
  {
    title: '版本名',
    scopedSlots: { customRender: 'versionName' },
  },
  { title: '跳过关卡', dataIndex: 'stage' },
  { title: '跳过游戏环节', dataIndex: 'stageType' },
  { title: '跳过原因', dataIndex: 'skipReason', scopedSlots: { customRender: 'skipReason' }, width: 220 },
  { title: '备注', dataIndex: 'remark' },
  { title: '跳过时间', dataIndex: 'skipTime', width: 150 },
  { title: '设备详情', dataIndex: 'userAgent', width: 140 },
  { title: '用户停留时长', dataIndex: 'stayTime', scopedSlots: { customRender: 'stayTime' } },
]
export default {
  name: 'CommentRecord',
  data() {
    return {
      moment,
      times: [moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
      search: {
        contentName: undefined,
        version: undefined,
        gameVersion: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
        gameId: undefined,
        endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        startTime: moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'),
      },
      columns,
      table: tableRelevant.call(this),
      gameList: [],
      gameListDuplicate: [],
      versionList: [],
      gameVersionList: [],
    }
  },
  created() {
    this.getGameSelect()
    // this.getList(1)
  },
  methods: {
    resetSearch() {
      for (let searchKey in this.search) {
        this.search[searchKey] = undefined
      }
      this.times = []
      // this.getList(1)
    },
    async exportExecl() {
      const data = []
      const tableData = await this.getAllList()
      for (let i = 0; i < tableData.length; i++) {
        const item = tableData[i]
        const dataItem = {}
        for (let j = 0; j < this.columns.length; j++) {
          const column = this.columns[j]
          const key = column.dataIndex
          let val = item[key]
          if (key === 'skipReason') {
            val = val.join(' ')
          }
          if (key == 'gender') {
            val = val == 1 ? '男' : '女'
          }
          if (key == 'stayTime') {
            val = this.formatTime(val)
          }
          dataItem[column.title] = val
        }
        data.push(dataItem)
      }
      console.log(data)

      // 2. 创建一个工作簿对象
      const wb = XLSX.utils.book_new()

      // 3. 将数据转换为工作表
      const ws = XLSX.utils.json_to_sheet(data)
      const colWidths = Array.from({ length: this.columns.length }, () => ({ wpx: 160 }))

      // 应用列宽
      ws['!cols'] = colWidths
      // 4. 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // 5. 导出为 Excel 文件
      XLSX.writeFile(wb, '跳过原因.xlsx')
    },
    formatTime(val) {
      if (!val) return '00:00:00'
      const timestamp = val
      const hours = Math.floor(timestamp / 3600)
      const minutes = Math.floor((timestamp % 3600) / 60)
      const seconds = timestamp % 60
      const formattedTime = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
      return formattedTime
    },
    updateVersionFilters(data) {
      const filters = (data || []).map((item) => ({
        text: item.version,
        value: item.version,
      }))
      this.$set(this.columns, 4, {
        ...this.columns[4],
        filters: filters,
        filteredValue: [],
      })
    },
    changeGameVersion(e) {
      // 根据游戏名称和版本名称确定唯一的游戏ID
      if (!this.search.contentName || !this.search.gameVersion) {
        return
      }
      // 清空版本号列表
      this.versionList = []
      const version = this.gameVersionList.find(f => f.versionName == e);
      if (version){
        EGamegeVersion({ id: version.id }).then((res) => {
          const versionData = res.data.data || []
          if (versionData && versionData.length > 0) {
            this.versionList = versionData
            this.updateVersionFilters(versionData)
          }
        })
      }
      
    },
    getVerSions(contentName) {
      this.versionList = []
      for (let i = 0; i < this.gameListDuplicate.length; i++) {
        const game = this.gameListDuplicate[i]
        if (contentName === game.name) {
          this.versionList.push({
            version: game.version,
            id: game.id,
          })
        }
      }
    },
    changeGame(e) {
      if (!e) {
        return
      }
      const game = this.gameList.find((v) => v.id == e) || {}
      this.search.contentName = game.name
      this.search.version = undefined
      this.search.gameVersion = undefined
      // 清空版本号列表
      this.gameVersionList = []
      // 获取游戏版本列表
      this.getGameVersions(game.name)
      if (this.$route.query.gameId) {
        this.search.gameVersion = this.gameVersionList.find(f => f.id == this.$route.query.gameId)?.versionName
        this.changeGameVersion(this.search.gameVersion)
        this.$router.replace({
          query: {}
        })
      }
      this.getList(1)
    },
    getGameVersions(contentName) {
      // 获取该游戏名下所有游戏记录
      this.gameVersionList = this.gameList.filter((v) => v.name === contentName).map(m => {
        m.dataIndex = m.versionName ? 1 : 9
        m.versionName = m.versionName || '--';
        return m;
      }).sort((a, b) => a.dataIndex - b.dataIndex);
    },
    updateVersionFilters(data) {
      const filters = (data || []).map((item) => ({
        text: item.version,
        value: item.version,
      }))
      this.$set(this.columns, 4, {
        ...this.columns[4],
        filters: filters,
        filteredValue: [],
      })
      // 更新表格版本名列的筛选选项
      const versionNames = [...new Set(data.map((item) => item.versionName).filter(Boolean))]
      const hasEmptyVersionName = data.some((item) => !item.versionName || item.versionName === '')
      if (hasEmptyVersionName) {
        versionNames.push('--')
      }
      if (versionNames.length > 0) {
        this.$set(this.columns, 5, {
          ...this.columns[5],
          filters: versionNames.map((vn) => ({
            text: vn,
            value: vn,
          })),
          filteredValue: [],
        })
      }
    },
    getGameSelect() {
      GamesComment.getAllContentByType({ contentTypeList: [1, 2] }).then((res) => {
        this.gameList = res.data || []
        this.gameListDuplicate = this.gameList.reduce((pre, cur) => {
          if (!pre.find((f) => f.name === cur.name)) {
            pre.push(cur)
          }
          return pre
        }, [])
        if (this.$route.query.gameId) {
          this.changeGame(this.$route.query.gameId)
        }
      })
    },
    filterOption(input, option) {
      const re = new RegExp(`[${input}]`, 'g')
      const match = option.componentOptions.children[0].text.match(re)
      if (match) {
        return match.length >= input.length
      }
      return false
    },
    changeRange(e = []) {
      if (e.length === 0) {
        this.search.startTime = undefined
        this.search.endTime = undefined
      } else {
        this.search.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$router.push({
        query: {
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      })
    },
    clearSearch() {
      this.search = {
        contentName: undefined,
        version: undefined,
        gameVersion: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      }
      // 重置版本号筛选条件
      this.$set(this.columns, 4, {
        ...this.columns[4],
        filters: [],
        filteredValue: [],
      })
      // 重置版本名筛选条件
      this.$set(this.columns, 5, {
        ...this.columns[5],
        filters: [],
        filteredValue: [],
      })
      // 清空版本号列表
      this.versionList = []
      this.getList(1)
    },
    handleTableChange(pagination, filters, sorter) {
      const { order = '', columnKey } = sorter
      const map = {
        ascend: false,
        descend: true,
      }
      this.search.OrderByDesc = map[order]
      if (typeof columnKey === 'string') {
        this.search.OrderByName = columnKey.slice(0, 1).toUpperCase() + columnKey.slice(1)
      }
      if (map[order] === undefined) {
        this.search.OrderByName = undefined
      }
      // 处理版本号筛选
      if (filters.Version) {
        this.search.version = filters.Version[0]
      } else {
        this.search.version = undefined
      }
      // 处理版本名筛选
      if (filters.versionName) {
        this.search.gameVersion = filters.versionName[0]
      } else {
        this.search.gameVersion = undefined
      }
      this.getList()
    },
    // 获取列表数据
    getList(pageIndex) {
      if (!this.search.contentName) {
        this.$message.error('请选择游戏名称')
        return
      }
      if (!this.search.startTime) {
        this.$message.error('请选择时间区间')
        return
      }

      let params = {
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.search,
      }
      if (params.version === '无版本名 ') {
        params.version = ''
      }
      // 将版本号参数名改为 contentVersion
      if (params.version !== undefined && params.version !== '') {
        params.contentVersion = params.version
        delete params.version
      }
      // 将版本名称参数名处理
      if (params.gameVersion === '无版本名 ') {
        params.gameVersion = ''
      }
      // 将版本名称参数名改为 VersionName
      if (params.gameVersion !== undefined) {
        // 选择"--"时传空字符串
        if (params.gameVersion === '--') {
          params.VersionName = ''
        } else {
          params.VersionName = params.gameVersion
        }
        delete params.gameVersion
      }
      params.minAge = params.minAge || undefined
      params.maxAge = params.maxAge || undefined
      this.table.tableLoading = true
      delete params.gameId
      ContentSkipInfoPageList(params)
        .then((res) => {
          const { data } = res
          this.table.tableDataSource = data.items
          this.table.tablePagination.total = data.totalCount
          this.table.tablePagination.current = data.pageIndex
          this.$nextTick(() => {
            this.updateVersionFilters(data.items)
          })
        })
        .finally(() => {
          this.table.tableLoading = false
        })
    },
    async getAllList() {
      let params = {
        pageIndex: 1,
        pageSize: 9999,
        ...this.search,
      }
      params.minAge = params.minAge || undefined
      params.maxAge = params.maxAge || undefined
      delete params.gameId
      // 将版本号参数名改为 contentVersion
      if (params.version !== undefined && params.version !== '') {
        params.contentVersion = params.version
        delete params.version
      }
      // 将版本名称参数名改为 VersionName
      if (params.gameVersion !== undefined) {
        if (params.gameVersion === '--') {
          params.VersionName = ''
        } else {
          params.VersionName = params.gameVersion
        }
        delete params.gameVersion
      }
      const { data: result } = await ContentSkipInfoPageList(params)
      return result.items
    },

    // 查看
    view(text) {
      text.id = text.contentId
      this.$store.commit('content/setTrainGameInfo', text)
      window.open('/content/Traingame/Statistics?type=2&name=' + text.contentName + '&versionName=' + (text.versionName || '--'))
    },
    disabledDate(current) {
      return current && current < moment('2019').startOf('day')
    },
  },
}
</script>

<style scoped>
.CommentRecord {
  position: relative;
}
.export-btn {
  position: absolute;
  right: 30px;
  top: -64px;
}
.table {
  margin-top: 15px;
}
</style>
